import * as tokens from '@hover/tokens-border';
import * as tokens$1 from '@hover/tokens-size';
import * as tokens$2 from '@hover/tokens-space';
import * as tokens$3 from '@hover/tokens-typography';

var radii = {
  200: tokens.radius200,
  300: tokens.radius300,
  400: tokens.radius400,
  500: tokens.radius500,
  900: tokens.radius900,
  round: tokens.radiusRound
};

var sizes = {
  25: tokens$1.size25,
  50: tokens$1.size50,
  75: tokens$1.size75,
  100: tokens$1.size100,
  200: tokens$1.size200,
  300: tokens$1.size300,
  350: tokens$1.size350,
  375: tokens$1.size375,
  400: tokens$1.size400,
  500: tokens$1.size500,
  600: tokens$1.size600,
  700: tokens$1.size700,
  750: tokens$1.size750,
  800: tokens$1.size800,
  850: tokens$1.size850,
  900: tokens$1.size900,
  checkbox: {
    small: tokens$1.sizeCheckboxSmall,
    medium: tokens$1.sizeCheckboxMedium,
    large: tokens$1.sizeCheckboxLarge
  },
  radio: {
    small: tokens$1.sizeRadioSmall,
    medium: tokens$1.sizeRadioMedium,
    large: tokens$1.sizeRadioLarge
  }
};

var space = {
  0: tokens$2.size0,
  50: tokens$2.size50,
  100: tokens$2.size100,
  200: tokens$2.size200,
  300: tokens$2.size300,
  400: tokens$2.size400,
  500: tokens$2.size500,
  600: tokens$2.size600,
  700: tokens$2.size700,
  800: tokens$2.size800,
  900: tokens$2.size900,
  1000: tokens$2.size1000,
  1100: tokens$2.size1100,
  1200: tokens$2.size1200
};

var typography = {
  fonts: {
    body: tokens$3.familyBody,
    brand: tokens$3.familyBrand,
    code: tokens$3.familyCode,
    display: tokens$3.familyDisplay
  },
  lineHeights: {
    50: tokens$3.height50,
    100: tokens$3.height100,
    200: tokens$3.height200,
    300: tokens$3.height300,
    400: tokens$3.height400,
    500: tokens$3.height500,
    600: tokens$3.height600,
    700: tokens$3.height700,
    800: tokens$3.height800,
    900: tokens$3.height900,
    1000: tokens$3.height1000
  },
  fontWeights: {
    100: tokens$3.weight100,
    300: tokens$3.weight300,
    400: tokens$3.weight400,
    500: tokens$3.weight500,
    600: tokens$3.weight600,
    700: tokens$3.weight700,
    body: tokens$3.weightBody,
    bodyBold: tokens$3.weightBodyBold,
    bodySemiBold: tokens$3.weightBodySemiBold,
    display: tokens$3.weightDisplay,
    heading: tokens$3.weightHeading,
    headingLight: tokens$3.weightHeadingLight
  },
  fontSizes: {
    50: tokens$3.size50,
    100: tokens$3.size100,
    200: tokens$3.size200,
    300: tokens$3.size300,
    400: tokens$3.size400,
    500: tokens$3.size500,
    600: tokens$3.size600,
    700: tokens$3.size700,
    800: tokens$3.size800,
    900: tokens$3.size900,
    1000: tokens$3.size1000,
    base: tokens$3.sizeBase
  }
};

export { sizes as a, radii as r, space as s, typography as t };
